import { PlusCircledIcon } from '@radix-ui/react-icons';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { CompetitionsDatatable } from '../components/datatables/competitionsDatatable';
import { Button } from '../components/ui/button';
import { AuthContext } from '../context/AuthContext';

const Competitions = () => {
    const { auth } = useContext(AuthContext);

    const navigate = useNavigate();

    return (
        <div className='flex w-full items-center justify-center'>
            <div className='flex w-5/6 sm:w-3/4 flex-col py-6 gap-3'>
                <div className='grid grid-cols-1 lg:grid-cols-2 items-start lg:gap-6'>
                    <div>
                        <h1 className='font-medium text-2xl'>Kommande tävlingar</h1>
                        <p className='text-muted-foreground text-sm'>Här visas alla kommande tävlingar.</p>
                    </div>
                    {(auth.user?.superadmin || auth.user?.roleInClub === 'admin') && (
                        <div className='grid grid-cols-1 xl:grid-cols-4 gap-3 pt-3'>
                            <Button className='xl:col-start-3 xl:col-span-2' onClick={() => navigate('/add-competition')}>
                                <PlusCircledIcon className='mr-3' />
                                Skapa ny tävling
                            </Button>
                        </div>
                    )}
                    {/* {isLoading ? (
                    <p>Loading...</p>
                ) : (
                    <ul className='w-5/6'>
                        {competitions.map(competition => (
                            <CompetitionItem competition={competition} />
                        ))}
                    </ul>
                )} */}
                </div>
                <CompetitionsDatatable />

            </div>
        </div>
    );
};

export default Competitions;